import { GypsyChoice } from "./choice";

export const gypsyChoiceOptions = Object.entries(GypsyChoice)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
